export default "__VITE_ASSET__DvxBxT1V__"